import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable camelcase */

var ArticleAdditionalColumn = function ArticleAdditionalColumn(_ref) {
  var value = _ref.value,
      name = _ref.name,
      data_type = _ref.data_type;
  return React.createElement('div', {
    className: 'additionalColumn'
  }, React.createElement('span', {
    className: 'additionalColumnLabel'
  }, name), value && React.createElement('span', {
    className: ['additionalColumnContent', data_type].join(' '),
    dangerouslySetInnerHTML: {
      __html: value
    }
  }));
};
/* eslint-enable camelcase */


ArticleAdditionalColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.any,
  name: PropTypes.string.isRequired,
  data_type: PropTypes.string.isRequired
} : {};
export default ArticleAdditionalColumn;